var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRowScrollArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_230",
    x: 0,
    y: 0,
    width: 111,
    height: 111,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.749
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Row_Scroll_Arrow",
    "data-name": "Row Scroll Arrow",
    transform: "translate(37.5 31.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -37.5, -31.5)",
    filter: "url(#Rectangle_230)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230-2",
    "data-name": "Rectangle 230",
    width: 36,
    height: 36,
    rx: 5,
    transform: "translate(37.5 31.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_231",
    "data-name": "Rectangle 231",
    width: 36,
    height: 36,
    rx: 5,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M8,0,0,8l8,8",
    transform: "translate(22.429 26.215) rotate(180)",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowScrollArrow);
export default __webpack_public_path__ + "static/media/Row Scroll Arrow.d883e5a911658048510444639defe3e9.svg";
export { ForwardRef as ReactComponent };